import CourseCard from "@modules/study/common/course_card";
import Select from "react-select";

import {
  FilterBoxCheckbox,
  FilterBoxSlider,
} from "@modules/study/common/advance_search/advance";
import { Collapse, Grid, Skeleton, SwipeableDrawer } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import ShowPaginateText from "@unisearch/common/ui_element/pagination/components/show_paginate_text";
import API from "@unisearch/helpers/api";
import { objectToQueryString } from "@unisearch/helpers/utils";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import { BiMoney } from "react-icons/bi";
import { FiSliders, FiX } from "react-icons/fi";
import { TbRefresh } from "react-icons/tb";
import useWindowDimensions from "_hooks/useWindowDimensions";
import Breadcrumb from "./components/breadcrumb";
import CardLayoutController from "./components/card_layout_controller";
import HeadingCourse from "./components/heading";
import styles from "./filtered_course.module.scss";
import { customStyles, sortingOptions } from "./components/sorting";

const showItemsData = [
  { id: 1, number: 8 },
  { id: 2, number: 12 },
  { id: 3, number: 16 },
  { id: 4, number: 20 },
];

export const UniFilteredCourses = ({
  country_name,
  university_name,
  universityProfileData,
  courseDurationData,
  examsData,
  levelsData,
  specializationsData,
  tutionFeeData,
  totalCoursesData,
  paginateData,
  courseOverviewText,
}) => {
  const router = useRouter();
  const { query } = router;

  const initPayload = {
    page: query?.page || 1,
    limit: query?.limit || 8,
    ...(router.query.crl && { crl: router.query.crl.split(",") }),

    ...(router.query.sp && { sp: router.query.sp.split(",") }),
    ...(router.query.ex && { ex: router.query.ex.split(",") }),
    ...(router.query.duration && {
      duration: router.query.duration.split(","),
      ...(router.query.tfees && { tfees: router.query.tfees.split(",") }),
    }),

    ...(router.query.sbp && { sbp: 1 }),
    ...(router.query.sbtfLH && { sbtfLH: 1 }),
    ...(router.query.sbtfHL && { sbtfHL: 1 }),
    ...(router.query.sbr && { sbr: 1 }),
  };

  const defaultSortValue = {
    value: "",
    label: "Default Sorting",
  };
  if (router.query.sbp) {
    defaultSortValue.value = "sbp";
    defaultSortValue.label = "Sort by Popularity";
  }
  if (router.query.sbtfLH) {
    defaultSortValue.value = "sbtfLH";
    defaultSortValue.label = "Sort by Tution Frees Low to High";
  }
  if (router.query.sbtfHL) {
    defaultSortValue.value = "sbtfHL";
    defaultSortValue.label = "Sort by Tution Frees High to Low";
  }
  if (router.query.sbr) {
    defaultSortValue.value = "sbr";
    defaultSortValue.label = "Sort by Rating";
  }

  const [levels, setLevels] = useState(levelsData);
  const [exams, setExams] = useState(examsData);
  const [specializations, setSpecializations] = useState(specializationsData);
  const [courseDuration, setCourseDuration] = useState(courseDurationData);
  const [tutionFee, setTutionFee] = useState(tutionFeeData);
  const [totalCourses, setTotalCourses] = useState(totalCoursesData);
  const [paginate, setPaginate] = useState(paginateData);
  const [loading, setLoading] = useState(false);
  const [respError, setRespError] = useState("");
  const [durationIsChangable, setDurationIsChangable] = useState(true);
  const [feeIsChangable, setFeeIsChangable] = useState(true);

  const [payload, setPayload] = useState(initPayload);
  const [showItem, setShowItem] = useState(query?.limit);

  const handlerShowItem = (number) => {
    setPayload((prev) => ({ ...prev, limit: number }));
  };

  const [open, setOpen] = useState(false);
  const [isAlignRow, setIsAlignRow] = useState(false);
  const { width } = useWindowDimensions();
  const [drawerState, setDrawerState] = useState(false);

  // sorting
  const [sorting, setSorting] = useState(defaultSortValue);

  //selected States
  const [checkedState, setCheckedState] = useState({
    checkedLevels: router?.query?.crl ? router?.query?.crl?.split(",") : [],
    checkedSpecializations: router?.query?.sp
      ? router?.query?.sp?.split(",")
      : [],
    checkedExam: router?.query?.ex ? router?.query?.ex?.split(",") : [],
  });

  // data prepare for checkboxes
  const checkboxDataForCourseLevel =
    levels && levels?.length > 0
      ? levels?.map((item) => ({
          label: item?.levelName,
          value: item?.slug,
        }))
      : [];
  const checkboxDataSpecialization =
    specializations && specializations?.length > 0
      ? specializations?.map((item) => ({
          label: item?.specializationName,
          value: item?.slug,
        }))
      : [];
  const checkboxDataForExam =
    exams && exams?.length > 0
      ? exams?.map((item) => ({
          label: item?.examName,
          value: item?.slug,
        }))
      : [];

  // Filtering handlers
  // search levels
  const searchLevels = (value) => {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState((prevState) => ({
      ...prevState,
      checkedLevels: value,
    }));
    setPayload((prevState) => ({
      ...prevState,
      crl: Array.from(new Set(value)),
    }));
  };
  // search specialization
  const searchSpecializations = (value) => {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState((prevState) => ({
      ...prevState,
      checkedSpecializations: value,
    }));

    setPayload((prevState) => ({
      ...prevState,
      sp: Array.from(new Set(value)),
    }));
  };
  // search specialization
  const searchExams = (value) => {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState((prevState) => ({
      ...prevState,
      checkedExam: value,
    }));
    setPayload((prevState) => ({
      ...prevState,
      ex: Array.from(new Set(value)),
    }));
  };
  //Search by duration
  const searchByDuration = (value) => {
    setDurationIsChangable(false);
    setFeeIsChangable(false);
    const valueString = value?.map((item) => item.toString());
    setPayload((prevState) => ({
      ...prevState,
      duration: valueString,
    }));
  };
  //Search by fees
  const searchByFees = (value) => {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    const valueString = value?.map((item) => item.toString());
    setPayload((prevState) => ({
      ...prevState,
      tfees: valueString,
    }));
  };

  // Sorting handler
  const sortHandler = (item) => {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    setSorting(item);
    const newPayload = { ...payload };
    delete newPayload.sbp;
    delete newPayload.sbtfLH;
    delete newPayload.sbtfHL;
    delete newPayload.sbr;
    delete newPayload.sbp;
    newPayload[item.value] = 1;
    setPayload(newPayload);
  };

  const closeDrawer = () => {
    setDrawerState(false);
  };
  const openDrawer = () => {
    setDrawerState(true);
  };
  const toggleDrawer = (newOpen) => () => {
    setDrawerState(newOpen);
  };
  const handleClick = () => {
    setOpen(!open);
  };

  // reset handler
  const resetHandler = () => {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setPayload({ page: 1, limit: 8 });
    setSorting({ value: "", label: "Default Sorting" });
    setCheckedState({
      checkedLevels: [],
      checkedSpecializations: [],
      checkedExam: [],
    });
    setShowItem(8);
  };

  // paginate handler
  const patinationHandler = (event, page) => {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    setPayload((prev) => ({ ...prev, page: page }));
  };

  // data fetching
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const res = await API.post(
          `/public/university/all-courses/${university_name}`,
          payload
        );
        if (res.data) {
          setLevels(res.data.levels ?? []);
          setExams(res.data.exams ?? []);
          setSpecializations(res.data.specializations ?? []);
          if (durationIsChangable) {
            setCourseDuration(res.data.courseDuration ?? {});
          }
          if (feeIsChangable) {
            setTutionFee(res.data.tuitionFee ?? {});
          }
          setTotalCourses(res.data.paginatedCourse.courses ?? []);
          setPaginate(res.data.paginatedCourse ?? {});
        }
        setLoading(false);
        router.push(
          `/study/${country_name}/university/${university_name}/courses?${objectToQueryString(
            payload
          ,{ shallow: true })}`,
          undefined,
          { shallow: true }
        );
      } catch (error) {
        setLoading(false);
        setRespError(error);
      }
    };
    fetchCourses();
  }, [payload]);

  const FilteredComponent = () => {
    return (
      <>
        {totalCourses?.length == 0 ? (
          <div></div>
        ) : (
          <div className={styles.filter_boxes_wrapper}>
            {levels && levels?.length > 0 && (
              <div className={styles.checkbox_wrapper}>
                <div className={styles.filter_title}>Course Level</div>
                <FilterBoxCheckbox
                  data={checkboxDataForCourseLevel}
                  onChange={searchLevels}
                  selected={checkedState.checkedLevels}
                  loading={loading}
                  type="normal"
                />
              </div>
            )}
            {specializations && specializations?.length > 0 && (
              <div className={styles.checkbox_wrapper}>
                <div className={styles.filter_title}>Specialization</div>
                <FilterBoxCheckbox
                  onChange={searchSpecializations}
                  data={checkboxDataSpecialization}
                  selected={checkedState.checkedSpecializations}
                  loading={loading}
                  type="normal"
                />
              </div>
            )}
            {exams && exams?.length > 0 && (
              <div className={styles.checkbox_wrapper}>
                <div className={styles.filter_title}>Eligibility Exam</div>
                <FilterBoxCheckbox
                  onChange={searchExams}
                  data={checkboxDataForExam}
                  selected={checkedState.checkedExam}
                  loading={loading}
                  type="normal"
                />
              </div>
            )}

            <div className={styles.filter_slider_wrapper}>
              {courseDuration?.maxDuration > 0 && (
                <div>
                  <div className={styles.filter_title}>Course Duration</div>
                  <FilterBoxSlider
                    type="normal"
                    range={[
                      parseInt(courseDuration.minDuration),
                      parseInt(courseDuration.maxDuration),
                    ]}
                    value={
                      payload?.duration && payload?.duration?.length == 2
                        ? [
                            parseInt(payload.duration[0]),
                            parseInt(payload.duration[1]),
                          ]
                        : [
                            parseInt(courseDuration.minDuration),
                            parseInt(courseDuration.maxDuration),
                          ]
                    }
                    onChange={searchByDuration}
                    loading={loading}
                    icon="m"
                    offset="right"
                  />
                </div>
              )}

              {tutionFee?.maxAmount > 0 && (
                <div>
                  <div className={styles.filter_title}>
                    Tution Fees(First Year)
                  </div>
                  <FilterBoxSlider
                    type="normal"
                    range={[0, parseInt(tutionFee.maxAmount)]}
                    value={
                      payload?.tfees && payload?.tfees?.length == 2
                        ? [
                            parseInt(payload.tfees[0]),
                            parseInt(payload.tfees[1]),
                          ]
                        : [0, parseInt(tutionFee.maxAmount)]
                    }
                    onChange={searchByFees}
                    loading={loading}
                    icon={<BiMoney />}
                    offset="left"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <section className={styles.course_component_container}>
      <div className="container">
        <HeadingCourse
          universityProfileData={universityProfileData}
          courseOverviewText={courseOverviewText}
        />

        {width > 992 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Breadcrumb universityProfileData={universityProfileData} />
            {totalCourses && totalCourses?.length > 0 && (
              <ShowPaginateText paginate={paginate} />
            )}
          </div>
        )}

        <div className={`${styles.filtered_wrapper} course_filtered_wrapper`}>
          <div className={styles.filtered_heading}>
            <div className={styles.fi_heading_wrapper}>
              {width > 992 ? (
                <>
                  <div className={styles.btn_container}>
                    {totalCourses?.length > 0 && (
                      <span
                        role="button"
                        className={`${styles.collapse_btn} ${styles.btn_toggle}`}
                        onClick={handleClick}
                      >
                        <FiSliders className={styles.collapse_icon} />
                        {!open ? "Show" : "Hide"} filter
                      </span>
                    )}

                    <span
                      role="button"
                      onClick={resetHandler}
                      className={styles.collapse_btn}
                    >
                      <TbRefresh className={styles.collapse_icon} />
                      Reset
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.mobile_btn}>
                    {totalCourses && totalCourses?.length > 0 && (
                      <>
                        {width < 660 && (
                          <ShowPaginateText paginate={paginate} />
                        )}
                      </>
                    )}

                    <span className={styles.collapse_btn} onClick={openDrawer}>
                      <FiSliders className={styles.collapse_icon} />
                      Show filter
                    </span>
                  </div>
                </>
              )}

              {totalCourses?.length > 0 && (
                <>
                  {width > 660 ? (
                    <div className={styles.right_wrapper}>
                      <div className={styles.show_item_wrapper}>
                        <div className={styles.show}>Show : </div>
                        {showItemsData.map((item, i) => {
                          return (
                            <Fragment key={i}>
                              <div
                                onClick={() => {
                                  setShowItem(item.number);
                                  handlerShowItem(item.number);
                                }}
                                className={`${styles.number} ${
                                  item.number == showItem ? styles.active : ""
                                }`}
                              >
                                {item?.number}
                              </div>
                              <div className={styles.line}>/</div>
                            </Fragment>
                          );
                        })}
                      </div>

                      {width > 992 ? (
                        <CardLayoutController
                          isAlignRow={isAlignRow}
                          setIsAlignRow={setIsAlignRow}
                        />
                      ) : (
                        <></>
                      )}
                      <div className={styles.shorting_filter}>
                        <Select
                          id="selectID"
                          instanceId={"testid"}
                          styles={customStyles}
                          placeholder="Default sorting"
                          onChange={sortHandler}
                          options={sortingOptions}
                          defaultValue={sorting}
                          value={sortingOptions.filter(
                            (item) => item.value == sorting.value
                          )}
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          </div>

          {width > 992 && (
            <Fragment>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <FilteredComponent />
              </Collapse>
            </Fragment>
          )}
        </div>

        <div style={{ marginTop: "20px" }}>
          {totalCourses?.length == 0 ? (
            <div className={styles.no_course_found}>No Course Found</div>
          ) : (
            <Grid container spacing={{ xs: 2, sm: 1 }}>
              {loading ? (
                <>
                  {new Array(8).fill(1).map((_, i) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={isAlignRow ? 12 : 6}
                        md={isAlignRow ? 12 : 4}
                        lg={isAlignRow ? 12 : 3}
                        key={i}
                      >
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width={"100%"}
                          height={isAlignRow ? 80 : 275}
                          style={{ borderRadius: 8 }}
                        />
                      </Grid>
                    );
                  })}
                </>
              ) : (
                <>
                  {totalCourses.map((course, i) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={isAlignRow ? 12 : 6}
                        md={isAlignRow ? 12 : 4}
                        lg={isAlignRow ? 12 : 3}
                        key={i}
                      >
                        <CourseCard
                          isAlignRow={isAlignRow}
                          key={i}
                          link={`/study/${country_name}/university/${university_name}/${course?.slug}`}
                          name={course?.courseName}
                          level={course?.level?.levelName}
                          exams={course?.courseExam}
                          session={course?.sessionName}
                          duration={course?.courseDuration}
                          intakes={course?.intake}
                          amountFrom={course?.tuition?.amountFrom}
                          amountTo={course?.tuition?.amountTo}
                          countryCurrency={
                            universityProfileData?.countryCurrency
                          }
                        />
                      </Grid>
                    );
                  })}
                </>
              )}
            </Grid>
          )}
        </div>
        {totalCourses && totalCourses?.length > 0 && (
          <PaginationComponent
            paginate={paginate}
            paginationHandler={patinationHandler}
          />
        )}

        <SwipeableDrawer
          anchor="left"
          classes={{ paper: styles.person_list_drawer }}
          open={drawerState}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          disableSwipeToOpen={false}
          ModalProps={{ keepMounted: true }}
        >
          <div className={styles.filter_drawer}>
            <div className={styles.filter_drawer_head}>
              <h4 className={styles.filter_title}>Filter Your Result</h4>
              <FiX onClick={closeDrawer} className={styles.close_icon} />
            </div>

            {totalCourses?.length > 0 ? (
              <Fragment>
                {width < 660 ? (
                  <div className={styles.mobile_sorting_wrapper}>
                    <div className={styles.show_item_wrapper}>
                      <div className={styles.show}>Show : </div>
                      {showItemsData.map((item, i) => {
                        return (
                          <Fragment key={i}>
                            <div
                              onClick={() => {
                                setShowItem(item.number);
                                handlerShowItem(item.number);
                              }}
                              className={`${styles.number} ${
                                item.number == showItem ? styles.active : ""
                              }`}
                            >
                              {item?.number}
                            </div>
                            <div className={styles.line}>/</div>
                          </Fragment>
                        );
                      })}
                    </div>

                    <div className={styles.shorting_filter}>
                      <Select
                        id="selectID"
                        instanceId={"testid"}
                        styles={customStyles}
                        placeholder="Default sorting"
                        onChange={sortHandler}
                        options={sortingOptions}
                        defaultValue={sorting}
                        value={sortingOptions.filter(
                          (item) => item.value == sorting.value
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <FilteredComponent />
              </Fragment>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No course Found
              </div>
            )}

            <div className={styles.filter_all_btn_wrapper}>
              <button
                type="button"
                onClick={resetHandler}
                className={`btn btn-outline btn-sm`}
              >
                Reset All
              </button>

              {totalCourses?.length > 0 && (
                <button
                  type="button"
                  className={`btn btn-primary btn-sm`}
                  onClick={closeDrawer}
                >
                  Apply All Filters
                </button>
              )}
            </div>
          </div>
        </SwipeableDrawer>
      </div>
    </section>
  );
};

export default UniFilteredCourses;
